module.exports = __webpack_public_path__ + "static/media/miami-7.a8a95cfb.jpg";